import { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from 'components/Modal';
import Button from 'components/UI/Button';
import { ReactComponent as CheckIcon } from 'assets/icons/digital-loan-check.svg';
import { ReactComponent as AlertIcon } from 'assets/icons/alert-triangle.svg';

const GuaranteeAvailabilityScreen = ({
  literals,
  onHasProduct,
  onNoProductUnderstood,
  onBack,
}) => {
  const [showRequirementModal, setShowRequirementModal] = useState(false);
  const [showNoProductModal, setShowNoProductModal] = useState(false);

  const handleYes = () => {
    setShowRequirementModal(true);
  };

  const handleNo = () => {
    setShowNoProductModal(true);
  };

  const handleRequirementContinue = () => {
    setShowRequirementModal(false);
    onHasProduct();
  };

  return (
    <div className='full-screen-container digital-loan-guarantee-availability'>
      <div className='screen-content'>
        <h1 className='digital-loan-phase2__title'>
          {literals.title}
        </h1>
        <p className='digital-loan-phase2__body mb-4'>{literals.subtitle}</p>
        <p className='digital-loan-phase2__section-title mb-3'>{literals.question}</p>
        <div className='digital-loan-guarantee-availability__choices'>
          <button
            type='button'
            className='digital-loan-guarantee-availability__choice'
            onClick={handleYes}
          >
            {literals.yes}
          </button>
          <button
            type='button'
            className='digital-loan-guarantee-availability__choice'
            onClick={handleNo}
          >
            {literals.no}
          </button>
        </div>
      </div>
      <div className='screen-actions'>
        <Button text={literals.back} type='secondary' onClick={onBack} />
      </div>

      {showRequirementModal && (
        <Modal
          className='digital-loan-guarantee-modal'
          position='center'
          closeOnBackgroundClick={false}
          showCloseButton={false}
          onClose={() => {}}
        >
          <div className='digital-loan-guarantee-modal__content'>
            <h2 className='digital-loan-guarantee-modal__title'>
              {literals.requirementTitle}
            </h2>
            <ul className='digital-loan-guarantee-modal__list'>
              {(literals.requirementItems || []).map((item) => (
                <li key={item} className='digital-loan-guarantee-modal__item'>
                  <CheckIcon className='digital-loan-guarantee-modal__check' aria-hidden='true' />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
            <Button text={literals.understood} onClick={handleRequirementContinue} />
          </div>
        </Modal>
      )}

      {showNoProductModal && (
        <Modal
          className='digital-loan-rejection-sheet-modal'
          position='end'
          animation='slide-up-enter'
          closeOnBackgroundClick={false}
          showCloseButton={false}
          onClose={() => {}}
        >
          <div className='digital-loan-rejection-sheet'>
            <div className='digital-loan-rejection-sheet__badge-wrap'>
              <div className='digital-loan-rejection-sheet__badge'>
                <AlertIcon aria-hidden='true' />
              </div>
            </div>
            <h2 className='digital-loan-rejection-sheet__title'>
              {literals.noProductTitle}
            </h2>
            <p className='digital-loan-rejection-sheet__body'>
              {literals.noProductBody}
            </p>
            <p className='digital-loan-rejection-sheet__website'>
              {literals.noProductWebsiteIntro}
              {' '}
              <strong>{literals.noProductWebsiteLabel}</strong>
            </p>
            <div className='digital-loan-rejection-sheet__actions'>
              <Button
                text={literals.accept}
                onClick={onNoProductUnderstood}
              />
              <Button
                text={literals.cancel}
                type='secondary'
                onClick={() => setShowNoProductModal(false)}
              />
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};

GuaranteeAvailabilityScreen.propTypes = {
  literals: PropTypes.object.isRequired,
  onHasProduct: PropTypes.func.isRequired,
  onNoProductUnderstood: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
};

export default GuaranteeAvailabilityScreen;
